import { render, staticRenderFns } from "./CustomCalendar.vue?vue&type=template&id=5dd4f90c"
import script from "./CustomCalendar.vue?vue&type=script&lang=js"
export * from "./CustomCalendar.vue?vue&type=script&lang=js"
import style0 from "./CustomCalendar.vue?vue&type=style&index=0&id=5dd4f90c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports